"use strict";
"use client";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { ark } from '@ark-ui/react/factory';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';
import { createSlotRecipeContext } from './utils/create-slot-recipe-context.mjs';

const alertRecipe = tv({
  slots: withSlotScopeClasses("alert", {
    root: "bg-bg-default border rounded-md flex gap-3 p-4 w-full",
    content: "flex flex-col gap-1",
    description: "text-fg-muted text-sm leading-5",
    icon: "text-fg-default shrink-0 w-5 h-5",
    title: "text-fg-default font-semibold text-sm leading-5"
  })
});
const { withProvider, withContext } = createSlotRecipeContext(alertRecipe);
const Root = withProvider(
  ark.div,
  "root"
);
withContext(ark.div, "content");
withContext(ark.div, "description");
const Icon = withContext(ark.svg, "icon");
const Title = withContext(ark.h5, "title");

export { Icon, Root, Title };
